module.exports = __webpack_public_path__ + "img/w2.ecea7d9a.png";